import { Button } from 'antd';
import { t } from 'ttag';
import './accessNotAvailable.scss';
import AccessNotAvailableIllustration from '../accessDenied/assets/images/exclamation-icon-v2.png';

type AccessNotAvailableProps = {
  onGoBack: () => void;
  userEmail: string;
};

const AccessNotAvailable = (props: AccessNotAvailableProps) => (
  <div className="access-not-available">
    <img
      className="access-not-available__illustration"
      src={AccessNotAvailableIllustration}
      alt="access not available illustration"
    />
    <div className="access-not-available__content">
      <h3>{t`Access Not Available Yet`}</h3>
      <p>{t`You've signed in successfully, but your account doesn't have access to this system yet.`}</p>
      <div className="access-not-available__signed-in">
        {t`Signed in as:`} <span>{props.userEmail}</span>
      </div>
      <p>
        {t`If you think this is a mistake, try signing in again, or contact support and include the email address above:`}
      </p>
      <p>
        {t`Email:`} <a href="mailto:cs@biotricity.com">cs@biotricity.com</a>
        <br />
        {t`Phone number:`} <a href="tel:+18005904155">(+1) 800-590-4155</a>
      </p>
    </div>
    <Button
      onClick={props.onGoBack}
      className="access-not-available__button"
      block
      htmlType="button"
      size="large"
    >
      {t`Back to Sign In`}
    </Button>
  </div>
);

export default AccessNotAvailable;
